var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoctor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 87.39 102.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b1d313a2-4d5d-4cb4-a3ac-582fd5e7fb79,.bbd99b02-6dfd-41a6-9a68-f58a45674284,.f00787e3-0a67-47a6-ae66-c6d5ac535550{fill:none;}.af66a182-51d1-4540-98dc-c1972df745fb{stroke-width:3.34px;}.af66a182-51d1-4540-98dc-c1972df745fb,.bbd99b02-6dfd-41a6-9a68-f58a45674284{stroke-miterlimit:10;}.ae6c3416-32ce-4d88-b06d-d5f8bb4d50f6{clip-path:url(#bcda2ec5-b897-40fd-84fd-2abc59044f62);}.bbd99b02-6dfd-41a6-9a68-f58a45674284,.f00787e3-0a67-47a6-ae66-c6d5ac535550{stroke:#fff;stroke-linecap:round;stroke-width:2.92px;}.f00787e3-0a67-47a6-ae66-c6d5ac535550{stroke-linejoin:round;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "bcda2ec5-b897-40fd-84fd-2abc59044f62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b1d313a2-4d5d-4cb4-a3ac-582fd5e7fb79",
    d: "M1.67,96.45.06,87.37A34,34,0,0,1,34.17,53.2h19A34.41,34.41,0,0,1,87.35,87.55l-1.64,8.9a4,4,0,0,1-4,4h-76A4,4,0,0,1,1.67,96.45Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ebd3f0b0-9783-4d55-9050-d8ba3afddd91",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e479ffe8-22ff-4e84-87c2-9d6752080eca",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "af66a182-51d1-4540-98dc-c1972df745fb",
    cx: 43.67,
    cy: 23.03,
    r: 21.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "af66a182-51d1-4540-98dc-c1972df745fb",
    d: "M1.67,96.45V87.37a32.5,32.5,0,0,1,32.5-32.5h19a32.5,32.5,0,0,1,32.49,32.5v9.08a4,4,0,0,1-4,4h-76A4,4,0,0,1,1.67,96.45Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "ae6c3416-32ce-4d88-b06d-d5f8bb4d50f6"
  }, /*#__PURE__*/React.createElement("line", {
    className: "f00787e3-0a67-47a6-ae66-c6d5ac535550",
    x1: 30.25,
    y1: 66.88,
    x2: 30.25,
    y2: 52.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "f00787e3-0a67-47a6-ae66-c6d5ac535550",
    d: "M26.34,83.8H21.27V74.46a7.32,7.32,0,0,1,6.85-7.09,23.21,23.21,0,0,1,4.25,0,7.32,7.32,0,0,1,6.86,7.09V83.8H34.15"
  }), /*#__PURE__*/React.createElement("line", {
    className: "bbd99b02-6dfd-41a6-9a68-f58a45674284",
    x1: 59.69,
    y1: 52.33,
    x2: 59.69,
    y2: 73.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "bbd99b02-6dfd-41a6-9a68-f58a45674284",
    cx: 59.69,
    cy: 78.84,
    r: 4.92
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/doctor.78fd05b2752cb29f83c8272cbde053be.svg";
export { ForwardRef as ReactComponent };